import React from "react";
import PropTypes from "prop-types";

const XIcon = ({ color, size, onClick }) => {
  return (
    <svg
      id="CLOSE"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 24.748"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <g
        id="Rectangle_2312"
        data-name="Rectangle 2312"
        transform="translate(1.666) rotate(45)"
        fill={color}
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      >
        <rect width="32.999" height="2" rx="1" stroke="none" />
        <rect x="0.5" y="0.5" width="31.999" height="1" rx="0.5" fill="none" />
      </g>
      <g
        id="Rectangle_3185"
        data-name="Rectangle 3185"
        transform="translate(0 23.334) rotate(-45)"
        fill={color}
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      >
        <rect width="32.999" height="2" rx="1" stroke="none" />
        <rect x="0.5" y="0.5" width="31.999" height="1" rx="0.5" fill="none" />
      </g>
    </svg>
  );
};

XIcon.defaultProps = {
  color: "#fff",
  size: 25,
};

XIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default XIcon;
